var exports = {
  "kL": "x7be19a29--4efbcc--container",
  "Qs": "x7be19a29--4efbcc--content",
  "wm": "x7be19a29--4efbcc--logo",
  "Sl": "x7be19a29--4efbcc--image",
  "pj": "x7be19a29--4efbcc--plain",
  "Pv": "x7be19a29--4efbcc--letter",
  "pq": "x7be19a29--4efbcc--info",
};

module.exports = exports;
